import styled, { css } from 'styled-components';

export const Container = styled.div<{ fluid?: boolean }>`
  position: relative;
  width: ${props => (props.fluid ? '100%' : 'auto')};
`;

export const Trigger = styled.div<{ error?: boolean; disabled?: boolean; isOpen?: boolean }>`
  display: flex;
  align-items: center;
  min-height: 38px;
  border: 1px solid ${props => (props.error ? '#db2828' : '#d4d4d5')};
  border-radius: 4px;
  background: ${props => (props.disabled ? '#f5f8fa' : '#fff')};
  cursor: ${props => (props.disabled ? 'not-allowed' : 'text')};
  opacity: ${props => (props.disabled ? 0.7 : 1)};
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  ${props =>
    props.isOpen &&
    !props.error &&
    css`
      border-color: #59249b;
      box-shadow: 0 0 0 1px #59249b;
    `}

  &:hover {
    border-color: ${props => (props.disabled ? '#d4d4d5' : props.error ? '#db2828' : '#59249b')};
  }
`;

export const SearchInput = styled.input`
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  padding: 8px 12px;
  font-size: 14px;
  color: #333;
  min-width: 0;

  &::placeholder {
    color: #999;
  }

  &:disabled {
    cursor: not-allowed;
  }
`;

export const TriggerActions = styled.div`
  display: flex;
  align-items: center;
  padding-right: 8px;
  gap: 4px;
  flex-shrink: 0;
`;

export const ClearButton = styled.button`
  border: none;
  background: transparent;
  color: #999;
  cursor: pointer;
  padding: 4px;
  line-height: 1;
  font-size: 16px;

  &:hover {
    color: #666;
  }
`;

export const ChevronIcon = styled.span<{ isOpen?: boolean }>`
  display: inline-block;
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #666;
  transition: transform 0.15s ease;
  transform: ${props => (props.isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
`;

export const Panel = styled.div<{ openUpward?: boolean }>`
  position: absolute;
  left: 0;
  right: 0;
  z-index: 1000;
  background: #fff;
  border: 1px solid #d4d4d5;
  border-radius: 4px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  max-height: 240px;
  overflow-y: auto;

  ${props =>
    props.openUpward
      ? css`
          bottom: calc(100% + 4px);
        `
      : css`
          top: calc(100% + 4px);
        `}
`;

export const OptionItem = styled.div<{ isHighlighted?: boolean; isSelected?: boolean }>`
  padding: 10px 12px;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
  background: ${props =>
    props.isHighlighted ? '#f3edfc' : props.isSelected ? '#faf8ff' : '#fff'};

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: #f3edfc;
  }
`;

export const EmptyState = styled.div`
  padding: 16px 12px;
  color: #999;
  font-size: 14px;
  text-align: center;
`;

export const LoadingState = styled.div`
  padding: 16px 12px;
  color: #666;
  font-size: 14px;
  text-align: center;
`;
